<script setup lang="ts">
defineOptions({
  name: 'App',
});
</script>

<template>
  <router-view />
</template>
